export const APP_ERROR_CODE = {
  networkError: 'NETWORK_ERROR',
  unauthorized: 'UNAUTHORIZED',
  forbidden: 'FORBIDDEN',
  notFound: 'NOT_FOUND',
  wheelVersionConflict: 'WHEEL_VERSION_CONFLICT',
  emailAlreadyUsed: 'EMAIL_ALREADY_USED',
  subscriptionRequired: 'SUBSCRIPTION_REQUIRED',
  rateLimitExceeded: 'RATE_LIMIT_EXCEEDED',
  internalServerError: 'INTERNAL_SERVER_ERROR',
  invalidOrExpiredResetPasswordToken: 'INVALID_OR_EXPIRED_RESET_PASSWORD_TOKEN',
  emailVerificationToken: 'EMAIL_VERIFICATION_TOKEN',
  emailVerificationTokenUsed: 'EMAIL_VERIFICATION_TOKEN_USED',
  emailVerificationTokenExpired: 'EMAIL_VERIFICATION_TOKEN_EXPIRED',
  emailVerificationInvalidUser: 'EMAIL_VERIFICATION_INVALID_USER',
  emailVerificationInvalidEmail: 'EMAIL_VERIFICATION_INVALID_EMAIL',
  wheelLimitExceeded: 'WHEEL_LIMIT_EXCEEDED',
  wheelSessionsLimitExceeded: 'WHEEL_SESSIONS_LIMIT_EXCEEDED',
} as const;

export type AppErrorCode = (typeof APP_ERROR_CODE)[keyof typeof APP_ERROR_CODE];

const APP_ERROR_CODES: readonly string[] = Object.values(APP_ERROR_CODE);

export function isAppErrorCode(code: string): code is AppErrorCode {
  return APP_ERROR_CODES.includes(code);
}
